import React, { useEffect, useRef, useState } from "react";
import {
    Button, Table, Overlay,
    Popover
} from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import WidgetNote from "../../WidgetNote";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import DatePicker from "react-datepicker";
import SingleDateSummaryModal from "../../SingleDateSummaryModal";
import darkNoteIcon from "../../../../Assets/Images/CRM/darkNotes.svg";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import ticket from "../../../../Assets/Images/Revenue-management/tableTicket.svg";
import alarm from "../../../../Assets/Images/Revenue-management/tableAlarm.svg";
import EventViewModal from "../../../CommonComponent/EventViewModal";
import ToolsSingleTicketPopUp from "../../../CommonComponent/ToolsSingleTicketPopUp";


export const PickupAnalysis = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const tableData = [
        {
            "Dates": "2025-04-27",
            "RoomSold": 0,
            "Revenue": 0,
            "ADR": 0
        },
        {
            "Dates": "2025-04-28",
            "RoomSold": 0,
            "Revenue": 0,
            "ADR": 0
        },
        {
            "Dates": "2025-04-29",
            "RoomSold": 0,
            "Revenue": 0,
            "ADR": 0
        },
        {
            "Dates": "2025-04-30",
            "RoomSold": 0,
            "Revenue": 0,
            "ADR": 0
        }
    ];

    const OntheBooktableData = [
        {
            "Dates": "2025-04-27",
            "OnTheBook": 0,
            "REV": 0,
            "ADR": 0,
            "Forecast_RMS": 0,
            "R28AVG": 0,
            "Optimal_BAR": 0
        },
        {
            "Dates": "2025-04-28",
            "OnTheBook": 0,
            "REV": 0,
            "ADR": 0,
            "Forecast_RMS": 0,
            "R28AVG": 0,
            "Optimal_BAR": 0
        },
        {
            "Dates": "2025-04-29",
            "OnTheBook": 0,
            "REV": 0,
            "ADR": 0,
            "Forecast_RMS": 0,
            "R28AVG": 0,
            "Optimal_BAR": 0
        },
        {
            "Dates": "2025-04-30",
            "OnTheBook": 0,
            "REV": 0,
            "ADR": 0,
            "Forecast_RMS": 0,
            "R28AVG": 0,
            "Optimal_BAR": 0
        }
    ];

    const [tblids, settblids] = useState({
        pickup_threshold: commonService.GenerateGUID(),
    });

    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };

    const [showNoteSidebar, setShowNoteSidebar] = useState(false);

    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );

    const [startRangeDate, setStartRangeDate] = useState(para?.asOfDate ? new Date(para?.asOfDate) : new Date());

    const [endRangeDate, setEndRangeDate] = useState(para?.asOfDate ? new Date(para?.asOfDate) : new Date());

    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const [loading_1_pickup_threshold, setLoading_1_pickup_threshold] = useState(false);

    const [loading_7_pickup_threshold, setLoading_7_pickup_threshold] = useState(false);

    const [loading_14_pickup_threshold, setLoading_14_pickup_threshold] = useState(false);

    const [loading_custom_threshold, setLoading_custom_threshold] = useState(false);

    const [loading_on_the_book, setLoading_on_the_book] = useState(false);

    const [AllDataSet, setAllDataSet] = useState({
        OneDayPickup: [], SevenDayPickup: [], FourteenDayPickup: [], CustomDayPickup: []
    });

    const [OnTheBook, setOnTheBook] = useState(null);

    const [dates, setdates] = useState(null);

    const [_custom_threshold, set_custom_threshold] = useState(0);

    const [_1_threshold, set_1_threshold] = useState(0);

    const [_7_threshold, set_7_threshold] = useState(0);

    const [_14_threshold, set_14_threshold] = useState(0);

    const [noteDetail, setNoteDetail] = useState(null);

    const pickup_ALL_threshold = async () => {

        await pickup_1_threshold();

        await pickup_7_threshold();

        await pickup_14_threshold();

        await custom_threshold();
    };

    const pickup_1_threshold = async () => {
        setLoading_1_pickup_threshold(true);

        /*-----------------------oneday----------------------------------------*/
        let oneday = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.PICK_UP.ONE_DAY_PICKUP_THRESHOLD,
                body: {
                    "AsOfDate": para?.asOfDate,
                    "propertyCode": para?.propertyCode,
                    "threshold": _1_threshold ? parseInt(_1_threshold) : 0,
                },
            },
            false
        );

        let onedayresponse = apiResponse(false, oneday);
        let OneDayPickup = [];
        if (onedayresponse?.isValidate) {
            OneDayPickup = onedayresponse?.data?.data;

        }

        if (onedayresponse?.data?.threshold) {
            set_1_threshold(onedayresponse?.data?.threshold)
        }
        setAllDataSet(prev => ({
            ...prev,
            OneDayPickup: OneDayPickup,
        }));

        setLoading_1_pickup_threshold(false);

    };

    const pickup_7_threshold = async () => {
        setLoading_7_pickup_threshold(true);

        /*-----------------------------sevenday----------------------------------*/
        let sevenday = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.PICK_UP.SEVEN_DAY_PICKUP_THRESHOLD,
                body: {
                    "AsOfDate": para?.asOfDate,
                    "propertyCode": para?.propertyCode,
                    "threshold": _7_threshold ? parseInt(_7_threshold) : 0,
                },
            },
            false
        );

        let sevendayresponse = apiResponse(false, sevenday);
        let SevenDayPickup = [];
        if (sevendayresponse?.isValidate) {
            SevenDayPickup = sevendayresponse?.data?.data;
        }

        if (sevendayresponse?.data?.threshold) {
            set_7_threshold(sevendayresponse?.data?.threshold)
        }

        setAllDataSet(prev => ({
            ...prev,
            SevenDayPickup: SevenDayPickup,
        }));



        setLoading_7_pickup_threshold(false);
    };

    const pickup_14_threshold = async () => {
        setLoading_14_pickup_threshold(true);
        /*---------------------------fourteenday------------------------------------*/
        let fourteenday = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.PICK_UP.FOURTEEN_DAY_PICKUP_THRESHOLD,
                body: {
                    "AsOfDate": para?.asOfDate,
                    "propertyCode": para?.propertyCode,
                    "threshold": _14_threshold ? parseInt(_14_threshold) : 0,
                },
            },
            false
        );

        let fourteendayresponse = apiResponse(false, fourteenday);
        let FourteenDayPickup = [];
        if (fourteendayresponse?.isValidate) {
            FourteenDayPickup = fourteendayresponse?.data?.data;
        }

        if (fourteendayresponse?.data?.threshold) {
            set_14_threshold(fourteendayresponse?.data?.threshold)
        }

        setAllDataSet(prev => ({
            ...prev,
            FourteenDayPickup: FourteenDayPickup
        }));
        setLoading_14_pickup_threshold(false);
    };

    const custom_threshold = async () => {
        setLoading_custom_threshold(true)
        if (startRangeDate && endRangeDate) {
            let customday = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.SnapShot + API_URL.PICK_UP.CUSTOM_PICKUP_THRESHOLD,
                    body: {
                        "AsOfDate": para?.asOfDate,
                        "propertyCode": para?.propertyCode,
                        "threshold": _custom_threshold ? parseInt(_custom_threshold) : 0,
                        "startDate": commonService.getDateForNode(startRangeDate),
                        "endDate": commonService.getDateForNode(endRangeDate),
                    },
                },
                false
            );

            let customdayresponse = apiResponse(false, customday);

            if (customdayresponse?.isValidate) {
                setAllDataSet(prev => ({
                    ...prev,
                    CustomDayPickup: customdayresponse?.data?.data
                }));
            }
            else {
                setAllDataSet(prev => ({
                    ...prev,
                    CustomDayPickup: []
                }));
            }

            if (customdayresponse?.data?.threshold) {
                set_custom_threshold(customdayresponse?.data?.threshold)
            }
        }
        setLoading_custom_threshold(false)
    }

    const handleDateChange = (dates) => {
        const [start, end] = dates;
        setStartRangeDate(start);
        setEndRangeDate(end);
    };

    const clickedDateForNote = useRef();

    const selectedDate = useRef();

    useEffect(() => {
        if (api === 0) {
            setAllDataSet({
                OneDayPickup: tableData, SevenDayPickup: tableData, FourteenDayPickup: tableData, CustomDayPickup: tableData
            })
            setOnTheBook(OntheBooktableData);
            setdates(["2025-04-27", "2025-04-28", "2025-04-29", "2025-04-30",])
        } else {
            if (para?.asOfDate) {
                getEventList();
                pickup_ALL_threshold();
            }
        }
    }, [para?.asOfDate]);

    useEffect(() => {
        const fetchData = async () => {

            let AllDates = [];

            if (AllDataSet.OneDayPickup && AllDataSet.OneDayPickup.length > 0) {
                let datesArray = AllDataSet.OneDayPickup.map(item => item.Dates);
                AllDates = AllDates.concat(datesArray);
            }

            if (AllDataSet.SevenDayPickup && AllDataSet.SevenDayPickup.length > 0) {
                let datesArray = AllDataSet.SevenDayPickup.map(item => item.Dates);
                AllDates = AllDates.concat(datesArray);
            }

            if (AllDataSet.FourteenDayPickup && AllDataSet.FourteenDayPickup.length > 0) {
                let datesArray = AllDataSet.FourteenDayPickup.map(item => item.Dates);
                AllDates = AllDates.concat(datesArray);
            }

            if (AllDataSet.CustomDayPickup && AllDataSet.CustomDayPickup.length > 0) {
                let datesArray = AllDataSet.CustomDayPickup.map(item => item.Dates);
                AllDates = AllDates.concat(datesArray);
            }

            const distinctSortedDates = [...new Set(AllDates)].sort();
            // setdates(distinctSortedDates);
 
            // Below Logic is verified from Meet.
            const today = moment().format("YYYY-MM-DD");
            const data = distinctSortedDates?.filter(
            (item) => moment(item).format("YYYY-MM-DD") >= today
            );
            setdates(data);
        };
        fetchData();
    }, [AllDataSet]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading_on_the_book(true);
            if (api !== 0) {
                if (dates && dates.length > 0) {
                    const commaSeparatedDates = dates.join(",");

                    let on_the_book = await apiCall(
                        {
                            method: "POST",
                            url: API_URL.BASE_API_URL.SnapShot + API_URL.PICK_UP.THRESHOLD_ON_THE_BOOK,
                            body: {
                                "AsOfDate": para?.asOfDate,
                                "propertyCode": para?.propertyCode,
                                "Dates": commaSeparatedDates,
                                "propertyid": propertyDetailFromRTK?.propertyid,
                                "ForcastType": propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term ? propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term.toLowerCase() : "ema"
                            },
                        },
                        false
                    );

                    let on_the_bookresponse = apiResponse(false, on_the_book);

                    if (on_the_bookresponse?.isValidate) {
                        setOnTheBook(on_the_bookresponse?.data?.data);
                    }



                    let noteByDataListResponse = await apiCall(
                        {
                            method: "POST",
                            url:
                                API_URL.BASE_API_URL.Configuration +
                                API_URL.WIDGET_NOTE.GET_BY_DATA_LIST,
                            body: {
                                propertyid: propertyDetailFromRTK?.propertyid,
                                widgetid: 0,
                                startdate: dates[0],
                                enddate: dates[dates.length - 1],
                            },
                        },
                        false
                    );

                    let noteByDataresponse = apiResponse(false, noteByDataListResponse);

                    if (noteByDataresponse?.isValidate) {
                        setNoteDetail(noteByDataresponse?.data?.data);
                    }

                    if (!noteByDataresponse?.isValidate) {
                        setNoteDetail(null);
                    }

                    let reminderListResponse = await apiCall(
                        {
                            method: "POST",
                            url: API_URL.BASE_API_URL.RevenueManagement + API_URL.REMINDER.GET_LIST,
                            body: {
                                pageNum: 1,
                                pageSize: 10,
                                sortColumn: "",
                                sortDirection: "asc",
                                searchValue: "",
                                propertyid: propertyDetailFromRTK?.propertyid,
                                startdate: dates[0],
                                enddate: dates[dates.length - 1],
                                remindername: "",
                                remindertypeterm: "",
                            },
                        },
                        false
                    );

                    let reminderResponse = apiResponse(false, reminderListResponse);

                    if (reminderResponse?.isValidate) {
                        reminderListRef.current = reminderResponse?.data?.data;
                    }
                }

            }
            setLoading_on_the_book(false);
        };
        fetchData();
    }, [dates]);

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.pickup_threshold} ._OneDayPickupRoom`, "center"
    );

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.pickup_threshold} ._SevenDayPickupRoom`, "center"
    );

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.pickup_threshold} ._FourteenDayPickupRoom`, "center"
    );

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.pickup_threshold} ._OnTheBookOnTheBook`, "center"
    );

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.pickup_threshold} ._CustomDayPickupRoom`, "center"
    );

    const selectedTdIndexRef = useRef();

    const singleDateSelectedDateRef = useRef();

    const [ONTHEBOOKS, setONTHEBOOKS] = useState({
        IsDisplay: false,
        // Property: { top: 0, left: 0 },
        Target: null,
        Position: "top",
    });

    const handleFilterBtnClick = (event, PickupDays) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setONTHEBOOKS({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
            PickupDays: PickupDays ? PickupDays : "7Day"
        });
    };

    const closeSingleDate = () => {
        selectedTdIndexRef.current = -1;
        setONTHEBOOKS({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
            PickupDays: "7Day"
        });
    };
    const eventListRef = useRef();
    const reminderListPropsRef = useRef();
    const reminderListRef = useRef();
    const isReminderRef = useRef();
    const clickedDateRef = useRef();
    const [showTicketModal, setShowTicketModal] = useState(false);
    const selectedEventDateRef = useRef();
    const eventListPropsRef = useRef();
    const [showToolsSummaryModal, setToolsSummaryModal] = useState(false);
    const [viewReminderModal, setViewReminderModal] = useState(false);
    const eventRef = useRef();

    const closeViewReminderModal = () => {
        setViewReminderModal(false);
    };

    const closeTicketModal = () => {
        setShowTicketModal(false);
    };
    const [groupModal, setGroupModal] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });
    const closeGroupDate = () => {
        clickedDateRef.current = "";
        setGroupModal({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const getEventList = async () => {
        let eventListResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: parseInt(propertyDetailFromRTK?.propertyid),
                    startdate: null,
                    enddate: null,
                    eventname: "",
                    eventtypeterm: "",
                    yearterm: ``,
                },
            },
            false
        );

        let response = apiResponse(false, eventListResponse);

        if (response?.isValidate) {
            eventRef.current = response?.data?.data;
            let eventListArr = [];

            response?.data?.data?.forEach((item) => {
                try {
                    let singleEventObj = {
                        id: item?.eventid ? item?.eventid : 0,
                        name: item?.eventname,
                        detail: item?.eventdetails,
                        startDate: item?.startdate,
                        endDate: item?.enddate,
                        eventJson: item?.eventjson,
                        eventResourceId: item?.eventsourceid,
                    };
                    let eventJsonData = "";
                    if (item?.eventjson) {
                        var decodedString = decodeURIComponent(item?.eventjson);
                        const jsonStringWithoutQuotes = decodedString.slice(1, -1);
                        const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
                        eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
                        let desc = eventJsonData?.description?.replaceAll("+", " ");
                        singleEventObj = {
                            ...singleEventObj,
                            labels: eventJsonData?.labels ? eventJsonData?.labels : "",
                            rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
                            local_rank: eventJsonData?.local_rank
                                ? eventJsonData?.local_rank
                                : 0,
                            phq_attendance: eventJsonData?.phq_attendance
                                ? eventJsonData?.phq_attendance
                                : 0,
                            geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
                            geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
                            detail: desc,
                        };
                    }
                    eventListArr.push(singleEventObj);
                }
                catch (err) { }
            });

            eventListRef.current = eventListArr;
        }

        if (!response?.isValidate) {
            eventRef.current = null;
            eventListRef.current = null;
        }
    };

    return (
        <div className="widget-container" style={{position: "relative"}}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.pickup_threshold,
                                    "Pickup Analysis",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.PickupAnalysis,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.pickup_threshold}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.pickup_threshold,
                                    `${para?.propertyCode}-Pickup Analysis-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                </div>
            )}
            <div className="ViewPropertySetupTable">
                {
                    <div className="stripped__table">
                        <div className="table-responsive tblDynamicPickupSticky">
                            <Table id={tblids.pickup_threshold}
                            className="table-with-spacing positionStaticTable dailySummaryTbl"
                            >
                                <thead className="tbl-header-sticky">
                                    <tr>
                                        <th style={{left: "0px", zIndex: 8}} rowSpan="2" className="border_right stickycolumn my-special-sticky">
                                            Note
                                        </th>
                                        <th style={{left: "0px", zIndex: 8}} rowSpan="2" className="text-center border_right stickycolumn my-special-sticky">
                                            Date
                                        </th>

                                        <th className="text-center border-right" colSpan="3">
                                            TRANSIENT CURRENT YEAR
                                        </th>

                                        <th className="text-center border-right" colSpan="3">
                                            Pricing & Forecast
                                        </th>


                                        <th className="text-center border-right" colSpan="3" style={{ width: "15%" }}>
                                            1 Day Pickup

                                            <div class="d-flex flex-row bd-highlight">
                                                <div class="search-group-for-table input-group">
                                                    <input
                                                        type="number"
                                                        value={_1_threshold}
                                                        aria-label="Search"
                                                        class="border-0 form-control"
                                                        id="customthreshold"
                                                        onChange={(e) => {
                                                            set_1_threshold(e.target.value);
                                                            /*custom_threshold(e.target.value);*/
                                                        }}
                                                        placeholder="Enter Threshold"
                                                    />
                                                </div>
                                                <input id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "1-day-pickup-rms", propertyCode)} type="button" value="Apply" onClick={(e) => pickup_1_threshold()} />
                                            </div>
                                        </th>

                                        <th className="text-center border-right" colSpan="3" style={{ width: "15%" }}>
                                            7 Day Pickup
                                            <div class="d-flex flex-row bd-highlight">
                                                <div class="search-group-for-table input-group">
                                                    <input
                                                        type="number"
                                                        value={_7_threshold}
                                                        aria-label="Search"
                                                        class="border-0 form-control"
                                                        id="customthreshold"
                                                        onChange={(e) => {
                                                            set_7_threshold(e.target.value);
                                                            /*custom_threshold(e.target.value);*/
                                                        }}
                                                        placeholder="Enter Threshold"
                                                    />
                                                </div>
                                                <input id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "7-day-pickup-rms", propertyCode)} type="button" value="Apply" onClick={(e) => pickup_7_threshold()} />
                                            </div>
                                        </th>

                                        <th className="text-center border-right" colSpan="3" style={{ width: "15%" }}>
                                            14 Day Pickup
                                            <div class="d-flex flex-row bd-highlight">
                                                <div class="search-group-for-table input-group">
                                                    <input
                                                        type="number"
                                                        value={_14_threshold}
                                                        aria-label="Search"
                                                        class="border-0 form-control"
                                                        id="customthreshold"
                                                        onChange={(e) => {
                                                            set_14_threshold(e.target.value);
                                                            /*custom_threshold(e.target.value);*/
                                                        }}
                                                        placeholder="Enter Threshold"
                                                    />
                                                </div>
                                                <input id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "14-day-pickup-rms", propertyCode)} type="button" value="Apply" onClick={(e) => pickup_14_threshold()} />
                                            </div>
                                        </th>

                                        <th className="text-center border-right " colSpan="3" style={{ width: "15%" }}>
                                            Custom Day Pickup
                                            <DatePicker id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "custom-day-pickup-rms", propertyCode)}
                                                portalId="datepicker-root"
                                                onChange={handleDateChange}
                                                className=""
                                                startDate={startRangeDate}
                                                endDate={endRangeDate}
                                                placeholderText="Start Date - End Date"
                                                selectsRange
                                                portalId="datepicker-root"
                                                monthsShown={2}
                                            />
                                            <div class="d-flex flex-row bd-highlight">
                                                <div class="search-group-for-table input-group">
                                                    <input
                                                        type="number"
                                                        value={_custom_threshold}
                                                        aria-label="Search"
                                                        class="border-0 form-control"
                                                        id="customthreshold"
                                                        onChange={(e) => {
                                                            set_custom_threshold(e.target.value);
                                                            /*custom_threshold(e.target.value);*/
                                                        }}
                                                        placeholder="Enter Threshold"
                                                    />
                                                </div>
                                                <input id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "custom-day-pickup-rms", propertyCode)} type="button" value="Apply" onClick={(e) => custom_threshold()} />
                                            </div>

                                        </th>
                                    </tr>
                                    <tr>
                                        <th className="text-center border-right">
                                            On The Books
                                        </th>
                                        <th className="text-end">
                                            ADR Change
                                        </th>
                                        <th className="text-end ">
                                            Rev
                                        </th>
                                        <th className="text-center border-right">
                                            Forecast
                                        </th>
                                        <th className="text-center">
                                            R28 Avg
                                        </th>
                                        <th className="text-center">
                                            Optimal BAR
                                        </th>
                                        <th className="text-center border-right">
                                            RMS
                                        </th>
                                        <th className="text-end">
                                            ADR Change
                                        </th>
                                        <th className="text-end">
                                            Rev
                                        </th>
                                        <th className="text-center border-right">
                                            RMS
                                        </th>
                                        <th className="text-end">
                                            ADR Change
                                        </th>
                                        <th className="text-end ">
                                            Rev
                                        </th>
                                        <th className="text-center border-right">
                                            RMS
                                        </th>
                                        <th className="text-end">
                                            ADR Change
                                        </th>
                                        <th className="text-end">
                                            Rev
                                        </th>

                                        <th className="text-center border-right">
                                            RMS
                                        </th>
                                        <th className="text-end">
                                            ADR Change
                                        </th>
                                        <th className="text-end">
                                            Rev
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        dates === null ? (
                                            <tr style={{ height: "80px", position: "relative" }}>
                                                <Loader />
                                            </tr>
                                        ) : (
                                            dates &&
                                            dates.map((item, index) => {

                                                let checkEvent = eventListRef.current?.filter(
                                                    (x) => {
                                                        let checkingDate = moment(item);
                                                        let startingDate = moment(x?.startDate);
                                                        let endingDate = moment(x?.endDate);
                                                        if (
                                                            checkingDate.isSameOrAfter(startingDate) &&
                                                            checkingDate.isSameOrBefore(endingDate)
                                                        ) {
                                                            return x;
                                                        }
                                                    }
                                                );

                                                let checkReminder =
                                                    reminderListRef.current?.filter((x) => {
                                                        let checkingDate = moment(item);
                                                        let startingDate = moment(x?.startdate);
                                                        let endingDate = moment(x?.enddate);
                                                        if (
                                                            checkingDate.isSameOrAfter(startingDate) &&
                                                            checkingDate.isSameOrBefore(endingDate)
                                                        ) {
                                                            return x;
                                                        }
                                                    });

                                                let checkNoteExists =
                                                    noteDetail?.notedata?.filter(
                                                        (x) =>
                                                            moment(x?.datadate).format("YYYY-MM-DD") ===
                                                            moment(item).format("YYYY-MM-DD")
                                                    );

                                                let OneDayPickupRoom = "";
                                                let _OneDayPickupRoom = 0;
                                                let OneDayPickupAdr = "";
                                                let OneDayPickupRev = "";

                                                if (AllDataSet.OneDayPickup && AllDataSet.OneDayPickup.length > 0) {
                                                    let OneDayPickup_Filter = AllDataSet.OneDayPickup.filter(i => moment(i.Dates).format("L") === moment(item).format("L"));
                                                    if (OneDayPickup_Filter && OneDayPickup_Filter.length > 0) {
                                                        if (OneDayPickup_Filter[0].RoomSold) {
                                                            OneDayPickupRoom = OneDayPickup_Filter[0].RoomSold;
                                                            _OneDayPickupRoom = parseInt(OneDayPickup_Filter[0].RoomSold);
                                                        }
                                                        if (OneDayPickup_Filter[0].ADR)
                                                            OneDayPickupAdr = commonService.formateAmount(OneDayPickup_Filter[0].ADR);

                                                        if (OneDayPickup_Filter[0].Revenue)
                                                            OneDayPickupRev = commonService.formateAmount(OneDayPickup_Filter[0].Revenue);
                                                    }
                                                }


                                                let SevenDayPickupRoom = "";
                                                let _SevenDayPickupRoom = 0;
                                                let SevenDayPickupAdr = "";
                                                let SevenDayPickupRev = "";

                                                if (AllDataSet.SevenDayPickup && AllDataSet.SevenDayPickup.length > 0) {
                                                    let SevenDayPickup_Filter = AllDataSet.SevenDayPickup.filter(i => moment(i.Dates).format("L") === moment(item).format("L"));
                                                    if (SevenDayPickup_Filter && SevenDayPickup_Filter.length > 0) {
                                                        if (SevenDayPickup_Filter[0].RoomSold) {
                                                            SevenDayPickupRoom = SevenDayPickup_Filter[0].RoomSold;
                                                            _SevenDayPickupRoom = parseInt(SevenDayPickup_Filter[0].RoomSold);
                                                        }

                                                        if (SevenDayPickup_Filter[0].ADR)
                                                            SevenDayPickupAdr = commonService.formateAmount(SevenDayPickup_Filter[0].ADR);

                                                        if (SevenDayPickup_Filter[0].Revenue)
                                                            SevenDayPickupRev = commonService.formateAmount(SevenDayPickup_Filter[0].Revenue);
                                                    }
                                                }

                                                let FourteenDayPickupRoom = "";
                                                let _FourteenDayPickupRoom = 0;
                                                let FourteenDayPickupAdr = "";
                                                let FourteenDayPickupRev = "";

                                                if (AllDataSet.FourteenDayPickup && AllDataSet.FourteenDayPickup.length > 0) {
                                                    let FourteenDayPickup_Filter = AllDataSet.FourteenDayPickup.filter(i => moment(i.Dates).format("L") === moment(item).format("L"));
                                                    if (FourteenDayPickup_Filter && FourteenDayPickup_Filter.length > 0) {
                                                        if (FourteenDayPickup_Filter[0].RoomSold) {
                                                            FourteenDayPickupRoom = FourteenDayPickup_Filter[0].RoomSold;
                                                            _FourteenDayPickupRoom = parseInt(FourteenDayPickup_Filter[0].RoomSold);
                                                        }

                                                        if (FourteenDayPickup_Filter[0].ADR)
                                                            FourteenDayPickupAdr = commonService.formateAmount(FourteenDayPickup_Filter[0].ADR);

                                                        if (FourteenDayPickup_Filter[0].Revenue)
                                                            FourteenDayPickupRev = commonService.formateAmount(FourteenDayPickup_Filter[0].Revenue);
                                                    }
                                                }

                                                let CustomDayPickupRoom = "";
                                                let _CustomDayPickupRoom = 0;
                                                let CustomDayPickupAdr = "";
                                                let CustomDayPickupRev = "";

                                                if (AllDataSet.CustomDayPickup && AllDataSet.CustomDayPickup.length > 0) {
                                                    let CustomDayPickup_Filter = AllDataSet.CustomDayPickup.filter(i => moment(i.Dates).format("L") === moment(item).format("L"));
                                                    if (CustomDayPickup_Filter && CustomDayPickup_Filter.length > 0) {
                                                        if (CustomDayPickup_Filter[0].RoomSold) {
                                                            CustomDayPickupRoom = CustomDayPickup_Filter[0].RoomSold;
                                                            _CustomDayPickupRoom = parseInt(CustomDayPickup_Filter[0].RoomSold);
                                                        }

                                                        if (CustomDayPickup_Filter[0].ADR)
                                                            CustomDayPickupAdr = commonService.formateAmount(CustomDayPickup_Filter[0].ADR);

                                                        if (CustomDayPickup_Filter[0].Revenue)
                                                            CustomDayPickupRev = commonService.formateAmount(CustomDayPickup_Filter[0].Revenue);
                                                    }
                                                }

                                                let OnTheBookOnTheBook = "";
                                                let _OnTheBookOnTheBook = 0;
                                                let OnTheBookREV = "";
                                                let OnTheBookADR = "";
                                                let OnTheBookForecast_RMS = "";
                                                let OnTheBookR28AVG = "";
                                                let OnTheBookOptimal_BAR = "";

                                                let foreCastSpiderTextColor = "";
                                                let forecastSpiderBorder = "";

                                                if (OnTheBook && OnTheBook.length > 0) {
                                                    let OnTheBook_Filter = OnTheBook.filter(i => moment(i.Date).format("L") === moment(item).format("L"));

                                                    if (OnTheBook_Filter && OnTheBook_Filter.length > 0) {
                                                        if (OnTheBook_Filter[0].OnTheBook) {
                                                            OnTheBookOnTheBook = OnTheBook_Filter[0].OnTheBook;
                                                            _OnTheBookOnTheBook = parseInt(OnTheBook_Filter[0].OnTheBook);
                                                        }

                                                        if (OnTheBook_Filter[0].ADR)
                                                            OnTheBookADR = commonService.formateAmount(OnTheBook_Filter[0].ADR);

                                                        if (OnTheBook_Filter[0].REV)
                                                            OnTheBookREV = commonService.formateAmount(OnTheBook_Filter[0].REV);

                                                        if (OnTheBook_Filter[0].Forecast_RMS)
                                                            OnTheBookForecast_RMS = OnTheBook_Filter[0].Forecast_RMS;

                                                        if (OnTheBook_Filter[0].R28AVG)
                                                            OnTheBookR28AVG = OnTheBook_Filter[0].R28AVG;

                                                        if (OnTheBook_Filter[0].Optimal_BAR)
                                                            OnTheBookOptimal_BAR = commonService.formateAmount(OnTheBook_Filter[0].Optimal_BAR);


                                                        if (
                                                            OnTheBook_Filter?.[0]?.Forecast_RMS &&
                                                            OnTheBook_Filter?.[0]?.R28AVG
                                                        ) {
                                                            if (
                                                                OnTheBook_Filter?.[0]?.Forecast_RMS <
                                                                OnTheBook_Filter?.[0]?.R28AVG
                                                            ) {
                                                                foreCastSpiderTextColor = "redText";
                                                                let R28AvgPercentage =
                                                                    (OnTheBook_Filter?.[0]?.R28AVG * 10) / 100;
                                                                let finalValue =
                                                                    OnTheBook_Filter?.[0]?.R28AVG - R28AvgPercentage;
                                                                if (OnTheBook_Filter?.[0]?.Forecast_RMS < finalValue) {
                                                                    forecastSpiderBorder = "redBorderTd";
                                                                }
                                                            } else {
                                                                let R28AvgPercentage =
                                                                    (OnTheBook_Filter?.[0]?.R28AVG * 10) / 100;
                                                                let finalValue =
                                                                    OnTheBook_Filter?.[0]?.R28AVG + R28AvgPercentage;
                                                                if (OnTheBook_Filter?.[0]?.Forecast_RMS > finalValue) {
                                                                    forecastSpiderBorder = "blackBorderTd";
                                                                }
                                                            }
                                                        }
                                                    }
                                                }


                                                return (
                                                    <React.Fragment key={index}>
                                                        <tr>
                                                            <td style={{left: "0px", zIndex: 8}} className="border_right stickycolumn my-special-sticky">
                                                                {checkNoteExists?.length > 0 ? (
                                                                    <img id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "note", item)}
                                                                        style={{ cursor: "pointer" }}
                                                                        src={darkNoteIcon}
                                                                        onClick={() => {
                                                                            clickedDateForNote.current = item;
                                                                            setShowNoteSidebar(true);
                                                                        }}
                                                                        alt="note"
                                                                    />
                                                                ) : (
                                                                    <img id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "note", item)}
                                                                        style={{ cursor: "pointer" }}
                                                                        src={NoteIcon}
                                                                        onClick={() => {
                                                                            clickedDateForNote.current = item;
                                                                            setShowNoteSidebar(true);
                                                                        }}
                                                                        alt="note"
                                                                    />
                                                                )}
                                                            </td>
                                                            <td style={{left: "0px", zIndex: 8}} className="border_right stickycolumn my-special-sticky">
                                                                <div className="d-flex align-items-center gap-4">
                                                                    <div id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "date-date", item)}
                                                                        style={{ width: "100px" }}
                                                                        className="cursorPointer"
                                                                        onClick={() => {
                                                                            selectedDate.current = item;
                                                                            setToolsSummaryModal(true);
                                                                        }}
                                                                    >
                                                                        {`${commonService.getDateInFormat(
                                                                            commonService.convertDateInTimezone(
                                                                                item
                                                                            )
                                                                        )} ${moment(
                                                                            commonService.convertDateInTimezone(
                                                                                item
                                                                            ),
                                                                            "l"
                                                                        ).format("ddd")}`}
                                                                    </div>
                                                                    <div className="d-flex justify-content-between align-items-center gap-2 ticketAlarmReload">
                                                                        <img id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "ticket", item)}
                                                                            src={ticket}
                                                                            className={`iconcolor ${checkEvent?.length > 0
                                                                                ? "rateiq-img-visible"
                                                                                : "rateiq-img-hide"
                                                                                }`}
                                                                            alt="ticket"
                                                                            onClick={() => {
                                                                                closeGroupDate();
                                                                                selectedEventDateRef.current = item;
                                                                                eventListPropsRef.current =
                                                                                    checkEvent;
                                                                                setShowTicketModal(true);
                                                                            }}
                                                                        />

                                                                        <img id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "ticket", item)}
                                                                            className={`iconcolor ${checkReminder?.length > 0
                                                                                ? "rateiq-img-visible"
                                                                                : "rateiq-img-hide"
                                                                                }`}
                                                                            src={alarm}
                                                                            alt="ticket"
                                                                            onClick={() => {
                                                                                closeGroupDate();
                                                                                reminderListPropsRef.current =
                                                                                    checkReminder;
                                                                                isReminderRef.current = true;
                                                                                setViewReminderModal(true);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            {
                                                                loading_on_the_book ?
                                                                    index === 0 &&
                                                                    <td colSpan={6} rowSpan={dates.length} className="loader border-right">
                                                                        <Loader />
                                                                    </td>
                                                                    :
                                                                    <>
                                                                        <td className="text-primary text-center border-right perbackground _OnTheBookOnTheBook" value={_OnTheBookOnTheBook}>

                                                                            <span id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "span-onclick", item)}
                                                                                className={`${selectedTdIndexRef.current === index
                                                                                    ? "singleDateSummarySpan"
                                                                                    : ""
                                                                                    }`}
                                                                                onClick={(e) => {
                                                                                    singleDateSelectedDateRef.current = item;
                                                                                    handleFilterBtnClick(e, "7Day");
                                                                                    selectedTdIndexRef.current = index;
                                                                                }}
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                {OnTheBookOnTheBook}
                                                                            </span>
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {OnTheBookADR}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {OnTheBookREV}
                                                                        </td>

                                                                        <td className="text-center border-right">
                                                                            <div className="d-flex justify-content-center align-items-center">
                                                                                <p
                                                                                    className={`${foreCastSpiderTextColor} ${forecastSpiderBorder} m-0`}
                                                                                    style={{ padding: "2px" }}
                                                                                >
                                                                                    {OnTheBookForecast_RMS}
                                                                                </p>
                                                                            </div>
                                                                        </td>
                                                                        <td className="text-center">
                                                                            {OnTheBookR28AVG}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            {OnTheBookOptimal_BAR}
                                                                        </td>
                                                                    </>
                                                            }

                                                            {
                                                                loading_1_pickup_threshold ?
                                                                    index === 0 &&
                                                                    <td colSpan={3} rowSpan={dates.length} className="loader border-right">
                                                                        <Loader />
                                                                    </td>
                                                                    :
                                                                    <>
                                                                        <td className="text-primary text-center border-right perbackground _OneDayPickupRoom" value={_OneDayPickupRoom}>
                                                                            {/*{OneDayPickupRoom}*/}
                                                                            <span id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "span-onclick", item)}
                                                                                className={`${selectedTdIndexRef.current === index
                                                                                    ? "singleDateSummarySpan"
                                                                                    : ""
                                                                                    }`}
                                                                                onClick={(e) => {
                                                                                    singleDateSelectedDateRef.current = item;
                                                                                    handleFilterBtnClick(e, "1Day");
                                                                                    selectedTdIndexRef.current = index;
                                                                                }}
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                {OneDayPickupRoom}
                                                                            </span>
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {OneDayPickupAdr}
                                                                        </td>
                                                                        <td className="text-end ">
                                                                            {OneDayPickupRev}
                                                                        </td>


                                                                    </>
                                                            }

                                                            {
                                                                loading_7_pickup_threshold ?
                                                                    index === 0 &&
                                                                    <td colSpan={3} rowSpan={dates.length} className="loader border-right">
                                                                        <Loader />
                                                                    </td>
                                                                    :
                                                                    <>


                                                                        <td className="text-primary text-center border-right perbackground _SevenDayPickupRoom" value={_SevenDayPickupRoom}>
                                                                            {/*{SevenDayPickupRoom}*/}
                                                                            <span id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "span-onclick", item)}
                                                                                className={`${selectedTdIndexRef.current === index
                                                                                    ? "singleDateSummarySpan"
                                                                                    : ""
                                                                                    }`}
                                                                                onClick={(e) => {
                                                                                    singleDateSelectedDateRef.current = item;
                                                                                    handleFilterBtnClick(e, "7Day");
                                                                                    selectedTdIndexRef.current = index;
                                                                                }}
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                {SevenDayPickupRoom}
                                                                            </span>
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {SevenDayPickupAdr}
                                                                        </td>
                                                                        <td className="text-end ">
                                                                            {SevenDayPickupRev}
                                                                        </td>

                                                                    </>
                                                            }


                                                            {
                                                                loading_14_pickup_threshold ?
                                                                    index === 0 &&
                                                                    <td colSpan={3} rowSpan={dates.length} className="loader border-right">
                                                                        <Loader />
                                                                    </td>
                                                                    :
                                                                    <>

                                                                        <td className="text-primary text-center border-right perbackground _FourteenDayPickupRoom" value={_FourteenDayPickupRoom}>
                                                                            {/*{FourteenDayPickupRoom}*/}
                                                                            <span id={commonService.generateGlobalClickTrackerID("PickupAnalysis", "span-onclick", item)}
                                                                                className={`${selectedTdIndexRef.current === index
                                                                                    ? "singleDateSummarySpan"
                                                                                    : ""
                                                                                    }`}
                                                                                onClick={(e) => {
                                                                                    singleDateSelectedDateRef.current = item;
                                                                                    handleFilterBtnClick(e, "14Day");
                                                                                    selectedTdIndexRef.current = index;
                                                                                }}
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                {FourteenDayPickupRoom}
                                                                            </span>
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {FourteenDayPickupAdr}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {FourteenDayPickupRev}
                                                                        </td>
                                                                    </>
                                                            }


                                                            {
                                                                loading_custom_threshold ?
                                                                    index === 0 &&
                                                                    <td colSpan={3} rowSpan={dates.length} className="loader border-right">
                                                                        <Loader />
                                                                    </td>
                                                                    :
                                                                    <>
                                                                        <td className="text-center border-right perbackground _CustomDayPickupRoom" value={_CustomDayPickupRoom}>
                                                                            {CustomDayPickupRoom}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {CustomDayPickupAdr}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {CustomDayPickupRev}
                                                                        </td>
                                                                    </>
                                                            }
                                                        </tr>
                                                    </React.Fragment>
                                                );

                                            })
                                        )
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </div>
                }
            </div>
            {api !== 0 && <Comments widgetDetails={para} editorId={"PickupAnalysis"} />}
            {showTicketModal && (
                <EventViewModal
                    showModal={showTicketModal}
                    closeModal={closeTicketModal}
                    eventDetails={eventListPropsRef.current}
                    selectedDate={selectedEventDateRef.current}
                    getEventList={getEventList}
                />
            )}
            {viewReminderModal && (
                <ToolsSingleTicketPopUp
                    showModal={viewReminderModal}
                    closeModal={closeViewReminderModal}
                    eventDetails={reminderListPropsRef.current}
                    isReminder={isReminderRef.current}
                />
            )}
            {showNoteSidebar && (
                <WidgetNote
                    show={showNoteSidebar}
                    handleClose={closeNoteSideBar}
                    // widgetId={101}
                    widgetId={0}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={"Pickup Analysis"}
                    dateForNote={clickedDateForNote.current}
                />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}

            <Overlay
                show={ONTHEBOOKS.IsDisplay}
                target={ONTHEBOOKS.Target}
                placement={ONTHEBOOKS.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                    style={{ zIndex: 999999 }}
                >
                    <div className="horizontal-menu-option active">
                        <SingleDateSummaryModal
                            closeModal={closeSingleDate}
                            asOfDate={para?.asOfDate}
                            selectedDate={singleDateSelectedDateRef.current}
                            pickupDate={singleDateSelectedDateRef.current}
                            propertyDetail={{ propertyCode: para?.propertyCode }}
                            PickupDays={ONTHEBOOKS.PickupDays}
                        />
                    </div>
                </Popover>
            </Overlay>
        </div>
    );
};

export default PickupAnalysis;
